export default __webpack_public_path__ + "static/bald-0721cb2a81cc9ae72bccaf27641d7d3b.jpg";